 // Función para dar formato al monto
const formatearMonto = (monto) => {
    return monto.toLocaleString('es-CR', { style: 'currency', currency: 'CRC' });
};

export default formatearMonto;
